import { render, staticRenderFns } from "./IconVideoCameraSolid.vue?vue&type=template&id=1150d05a"
import script from "./IconVideoCameraSolid.vue?vue&type=script&lang=js"
export * from "./IconVideoCameraSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports